export const isMarkdownShapedLikeAScenario = (markdownText: string): boolean => {
  // Phase 7 (scenaria-english-support): recognize the fr|en scene-header token
  // union ("Scène" | "Scene", French "n°" | English "no."/"#" | omitted) so an
  // English-token scenario is still detected as scenario-shaped. Widen only;
  // emission stays French for now (plan D4 / L1).
  const sceneRegex = /^###\s+Sc[eè]ne\s+(?:n°|no\.?|#)?\s*\d+:/gm;
  const interactionRegex = /^-\s.*?:/gm;

  const scenes = markdownText.match(sceneRegex);
  if (!scenes || scenes.length === 0) return false;

  return scenes.some((scene, index) => {
    const currentSceneStart = markdownText.indexOf(scene);
    const nextSceneStart =
      index + 1 < scenes.length ? markdownText.indexOf(scenes[index + 1]) : markdownText.length;

    const sceneBlock = markdownText.slice(currentSceneStart, nextSceneStart);
    return interactionRegex.test(sceneBlock);
  });
};
